export enum CollectionKey {
  AccountInsulin = "account_insulins",
  AccountMedication = "account_medications",
  EntryTemplate = "entry_templates",
  Insulin = "insulins",
  Medication = "medications",
  UserEntry = "user_entries",
  UserEvent = "user_events",
}
